// Element Images (for Home page elements collection)
import EarthElementImg    from '../assets/images/Earth.jpg';
import WaterElementImg    from '../assets/images/Water_Nature.jpg';
import FireElementImg     from '../assets/images/Fire_Nature.jpg';
import AirElementImg      from '../assets/images/Air.jpg';
import EtherElementImg    from '../assets/images/Ether.jpg';
import Gift               from '../assets/images/Gift.png';

// Product Images (for Shop / Element landing pages)
import PrithviSoap from '../assets/images/soap/Prithvi_soap.png';
import JalSoap     from '../assets/images/soap/Jal_soap.png';
import AgniSoap    from '../assets/images/soap/agni_soap.png';
import VayuSoap    from '../assets/images/soap/vayu_soap.png';
import AkashSoap   from '../assets/images/soap/akash_soap.png';
import GiftImg     from '../assets/images/soap/gift_box.png';

const products = [
  {
    id: 1,
    nameKey: '1',
    descriptionKey: '1',
    price: 299,
    currency: '₹',
    image: PrithviSoap,
    elementImage: EarthElementImg, // For home page
    element: 'earth',
    category: 'soap',
    link: '/element/earth',
  },
  {
    id: 2,
    nameKey: '2',
    descriptionKey: '2',
    price: 299,
    currency: '₹',
    image: JalSoap,
    elementImage: WaterElementImg, // For home page
    element: 'water',
    category: 'soap',
    link: '/element/water',
  },
  {
    id: 3,
    nameKey: '3',
    descriptionKey: '3',
    price: 299,
    currency: '₹',
    image: AgniSoap,
    elementImage: FireElementImg, // For home page
    element: 'fire',
    category: 'soap',
    link: '/element/fire',
  },
  {
    id: 4,
    nameKey: '4',
    descriptionKey: '4',
    price: 299,
    currency: '₹',
    image: VayuSoap,
    elementImage: AirElementImg, // For home page
    element: 'air',
    category: 'soap',
    link: '/element/air',
  },
  {
    id: 5,
    nameKey: '5',
    descriptionKey: '5',
    price: 299,
    currency: '₹',
    image: AkashSoap,
    elementImage: EtherElementImg, // For home page
    element: 'ether',
    category: 'soap',
    link: '/element/ether',
  },
  {
    id: 6,
    nameKey: '6',
    descriptionKey: '6',
    price: 1299,
    currency: '₹',
    image: GiftImg,
    elementImage: Gift, // For home page
    element: 'gift',
    category: 'gift',
    link: '/element/gift',
  },
];

export default products;
